import styled, { css } from 'styled-components'

export const arrowProperty = css`
	bottom: 100%;
	border: solid transparent;
	content: '';
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
`

export const DropdownInner = styled.div`
	height: auto;
	overflow-x: hidden;
	overflow-y: scroll;
	padding-bottom: 16px;
`

export const DropdownWrapper = styled.div`
	width: 100%;
	position: ${props => props.position || 'relative'};
	top: ${props => props.positionTop};
	left: ${props => props.positionLeft};
	background-color: #fff;
	padding: 12px 20px 8px;
	min-height: ${props => props.minHeight};
	transform: ${props => props.transform};
	z-index: ${props => props.zIndex};

	${props =>
		props.allowInnerScroll &&
		css`
			height: 100%;
			overflow: auto;
			margin-bottom: 56px;
			padding-top: 0;

			${DropdownInner} {
				padding-bottom: 0;
			}
		`}

	${props =>
		props.arrowLeft &&
		css`
			:before,
			:after {
				${arrowProperty} left: 32px;
			}
		`};
	${props =>
		props.arrowCenter &&
		css`
			:before,
			:after {
				${arrowProperty} left: 50%;
				margin-left: -8px;
			}
		`};
	${props =>
		props.arrowRight &&
		css`
			:before,
			:after {
				${arrowProperty} right: 24px;
			}
		`};
	&:before {
		border-color: rgba(204, 23, 10, 0) rgba(204, 23, 10, 0) rgba(0, 0, 0, 0.02);
		border-width: 9px;
		${props =>
			props.arrowLeft &&
			css`
				margin-left: -1px;
			`};
		${props =>
			props.arrowCenter &&
			css`
				margin-left: -9px;
			`};
		${props =>
			props.arrowRight &&
			css`
				margin-right: -1px;
			`};
	}
	&:after {
		border-color: hsla(0, 0%, 100%, 0) hsla(0, 0%, 100%, 0) #fff;
		border-width: 8px;
		${props =>
			props.left &&
			css`
				margin-left: 1px;
			`};
		${props =>
			props.center &&
			css`
				margin-left: -8px;
			`};
		${props =>
			props.right &&
			css`
				margin-left: auto;
				margin-right: 1px;
			`};
	}
`

export const FooterButtonWrapper = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: ${props => props.padding || '4px'};
	background: #fff;
	box-shadow: 0px -1px 10px rgba(48, 80, 89, 0.3);
	display: flex;
	flex-wrap: nowrap;
	flex-direction: row;
`

// ${props =>
//     props.borderRight &&
//     css`
//       ${ButtonTag} {
//         &:first-child {
//           border-right: 1px solid rgba(0, 0, 0, 0.1);
//         }
//       }
//     `};
//   ${ButtonTag} {
//     width: 100%;
//     font-size: ${theme.mini};
//     line-height: 16px;
//     text-align: center;
//     letter-spacing: -0.218182px;
//     color: #555555;
//     border: 0;
//     border-radius: 0;
//     font-weight: ${theme.regular};
//     white-space: normal;
//     background-color: ${theme.white};
//   }
